import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import moment from "moment";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { IMinMaxDate, ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-skordningstid-filter",
    templateUrl: "./tpl-skordningstid-filter.component.html",
    styleUrls: ["./tpl-skordningstid-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        DatepickerComponent
    ]
})
export class TplSkordningstidFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {

    private current: IMinMaxDate;

    constructor() {
        super("skordningstid");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormGroup({
            min: new UntypedFormControl(null),
            max: new UntypedFormControl(null)
        }));
    }

    value(): IMinMaxDate {
        return this.control.value;
    }

    isActive(): boolean {
        return this.filterLength > 0;
    }

    match(item: ITplArbetsorder): boolean {
        return this.isDateBetween(item.grotSkordningAvslutadDatum, this.current);
    }

    prepare(): void {
        const value = this.value();
        this.current = {
            min: value.min ? moment(value.min).toDate() : new Date(0),
            max: value.max ? moment(value.max).toDate() : new Date(8640000000000000)
        };

    }

    protected onFilterInit(state: IMinMaxDate): void {
        state = {
            min: state?.min ?? null,
            max: state?.max ?? null
        };
        this.control.setValue(state);
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        this.filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: IMinMaxDate): void {
        this.filterLength = (value.min ? 1 : 0) + (value.max ? 1 : 0);
    }
}
